'use strict';

angular.module('cimerFrontEndApp').controller('MyCurriculaCtrl', ['$scope', '$location', '$uibModal', 'Session', 'BookBagService', 'DocumentService', 'ApiUrl', function ($scope, $location, $uibModal, Session, BookBagService, DocumentService, ApiUrl) {

    if (!Session.getSessionObject().isAuthenticated) {
        $location.url('/');
        return;
    }

    //setup and load options
    $scope.myBookbags = [];
    $scope.addingNewBookbag = false;
    $scope.message = '';
    $scope.currentBookbag = {
        BookBagID: null,
        Name: '',
        Description: '',
        BookBagDocuments: []
    };
    

    //load bookbag object from service if routed from search page
    var tempBookBag = BookBagService.getBookBagObject();
    if (tempBookBag && tempBookBag.hasOwnProperty("bookBagID") &&
        tempBookBag.docs.length &&
        tempBookBag.hasOwnProperty("name") &&
        tempBookBag.hasOwnProperty("description") &&
        tempBookBag.hasOwnProperty("docs")) {   //ensure object is well-formed
        //We are adding a new bookbag so set this state so we can hide the current ones.
        $scope.addingNewBookbag = true;
        $scope.currentBookbag.BookBagID = tempBookBag.bookBagID;
        $scope.currentBookbag.Name = tempBookBag.name;
        $scope.currentBookbag.Description = tempBookBag.description;

        
        for (var i = 0; i < tempBookBag.docs.length; i++) {
            $scope.currentBookbag.BookBagDocuments.push({
                BookBagDocumentID: tempBookBag.docs[i].bookBagDocID, 
                Document: {
                    DocumentID: tempBookBag.docs[i].docID,
                    Title: tempBookBag.docs[i].title
                },
                DocumentOrder: tempBookBag.docs[i].docOrder,
                IsSelected: tempBookBag.docs[i].isSelected
            });
        }
    }


    $scope.formSubmitted = false; //will update on save/download
    var getMyBookBags = function () {
        BookBagService.getMyBookBags().then(function (result) {
            $scope.myBookbags = result;
        }, function (err) {
            console.log(err);
        });
    };
    getMyBookBags();

    $scope.changeBookbag = function (bookBagId) {
        $scope.message = '';
        $scope.formSubmitted = false; //reset form warnings

        $scope.currentBookbag.BookBagID = bookBagId;
        if ($scope.currentBookbag.BookBagID === null) {  //its a new bookbag, insert empty object
            $scope.currentBookbag = {
                BookBagID: null,
                Name: '',
                Description: '',
                BookBagDocuments: []
            };
        }
        else {
            //load documents for this bookbag 
            BookBagService.getBookBagByID($scope.currentBookbag.BookBagID).then(function (result) {
                $scope.currentBookbag = result;
            }, function (err) {
                console.log(err);
            });
        }
    };

    $scope.removeDocument = function (index) {
        $scope.currentBookbag.BookBagDocuments.splice(index, 1);
    };

    $scope.addDocuments = function () {
        //add bookbag id and docids here (and some flag to trigger loading on search page?
        var tempDocs = [];
        for (var i = 0; i < $scope.currentBookbag.BookBagDocuments.length; i++) {
            tempDocs.push({
                docID: $scope.currentBookbag.BookBagDocuments[i].Document.DocumentID,
                bookBagDocID: $scope.currentBookbag.BookBagDocuments[i].BookBagDocumentID,
                title: $scope.currentBookbag.BookBagDocuments[i].Document.Title,
                docOrder: $scope.currentBookbag.BookBagDocuments[i].DocumentOrder,
                isSelected: $scope.currentBookbag.BookBagDocuments[i].IsSelected
            });
        }
        BookBagService.saveBookBagObject({
            bookBagID: $scope.currentBookbag.BookBagID,
            name: $scope.currentBookbag.Name,
            description: $scope.currentBookbag.Description,
            docs: tempDocs
        });

        $location.url('/searchCustomCurricula');
    };

    //This is going to make the save message disappear.
    $scope.sortableOptions = {
        update: function (e, ui) {
            $scope.bookbagForm.$setDirty();
        }
    };

    $scope.saveBookbag = function () { 
        $scope.formSubmitted = true;

        if (!$scope.bookbagForm.$invalid) { //only submit if form is valid
            processSort();
            BookBagService.saveBookBag($scope.currentBookbag).then(function (result) {
                //need to update select list to reflect new name (if any)
                if ($scope.currentBookbag.BookBagID === null) {  //it was a new bookbag, add to dropdown
                    $scope.myBookbags.push(result);
                } else { //updating an existing bookbag
                    for (var i = 0; i < $scope.myBookbags.length; i++) {
                        if ($scope.myBookbags[i].BookBagID === result.BookBagID) {
                            $scope.myBookbags[i] = result;
                            break;
                        }
                    }
                }

                //on successful save, the bookbag 'shopping cart' is cleared
                BookBagService.clearBookBagObject();
                $scope.currentBookbag = {
                    BookBagID: null,
                    Name: '',
                    Description: '',
                    BookBagDocuments: []
                };
                $scope.addingNewBookbag = false;
                $scope.formSubmitted = false;
                $scope.message = 'Your book has been saved.';
                $scope.bookbagForm.$setPristine();
            }, function (err) {
                console.log(err);
            });

        }
    
    };

    $scope.downloadBookbag = function (bookBagId) {

        $scope.message = '';

        if (bookBagId === undefined || bookBagId === null) {
            $scope.formSubmitted = true;
            if (!$scope.bookbagForm.$invalid) { //only submit if form is valid
                processSort();
                BookBagService.downloadBookbag($scope.currentBookbag);
            }
        }
        else {
            BookBagService.getBookBagByID(bookBagId).then(function (result) {
                BookBagService.downloadBookbag(result);
            }, function (err) {
                console.log(err);
            });
        }
    };
    
    $scope.setBookbagActiveState = function (bookbag) {
        var _toggleactiveapiUrl = ApiUrl.url('/BookBag/');
        var closeModal = $uibModal.open({
            animation: true,
            templateUrl: 'toggleActiveBookbag.html',
            controller: 'toggleActiveBookbagCtrl',
            resolve: {
            }
        });
        closeModal.result.then(function (accepted) {
            if (accepted) {
                bookbag.Inactive = true;
                BookBagService.setBookBagInactive(bookbag).then(function (result) {
                    $scope.message = 'Your book ' + bookbag.Name + ' has been deleted';
                    // Remove the deleted bookbag from the page
                    for (var i = 0; i < $scope.myBookbags.length; i++) {
                        if ($scope.myBookbags[i].BookBagID === result.BookBagID) {
                            $scope.myBookbags.splice(i, 1);
                            break;
                        }
                    }
                    // Check if the open bookbag was the one being deleted
                    if ($scope.currentBookbag.BookBagID === result.BookBagID) {
                        // Clear the form if the bookbag was open for editing when it was deleted
                        BookBagService.clearBookBagObject();
                        $scope.currentBookbag = {
                            BookBagID: null,
                            Name: '',
                            Description: '',
                            BookBagDocuments: []
                        };
                        $scope.addingNewBookbag = false;
                        $scope.formSubmitted = false;
                        $scope.bookbagForm.$setPristine();
                    }
                    
                }, function (err) {
                    console.log(err);
                });
            }
            
        },
            function () {
                // This is here to handle the modal pop-up being dimissed or cancelled
            }

        );
    };
    
    //need to update DocumentOrder to reflect ui-sortable changes
    var processSort = function () {
        for (var i = 0; i < $scope.currentBookbag.BookBagDocuments.length; i++) {
            $scope.currentBookbag.BookBagDocuments[i].DocumentOrder = i + 1;
        }
    };

}])

    .controller('toggleActiveBookbagCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        'use strict';

        $scope.accept = function () {
            $uibModalInstance.close(true);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }]);
    